import React from 'react';
import styles from './index.module.sass';
import {CustomButton2, CustomView} from "../../../../../panel/components";
import {useLocation} from "react-router-dom";

const logo = require('../../../../assets/sep.shaparak.png')

type Props = {};

const RedirectScreen: React.FC<Props> = (props: Props): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const location: any = useLocation();

  const [token      , setToken      ] = React.useState<string>('');
  const [price      , setPrice      ] = React.useState<string>('');
  const [phoneNumber, setPhoneNumber] = React.useState<string>('');

  const formRef: React.MutableRefObject<HTMLFormElement | null> = React.useRef<HTMLFormElement | null>(null);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function copyToClipboard(): void {
    const fullUrl: string = window.location.href;
    navigator.clipboard.writeText(fullUrl)
      .then(() => {
        alert("لینک پراخت کپی شد!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  }

  function redirectToPayment(): void {
    window.location.href = `https://sep.shaparak.ir/OnlinePG/SendToken?token=${token}`;
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect((): void => {
    const queryParams: URLSearchParams = new URLSearchParams(location.search);

    const token      : string | null = queryParams.get('token'      );
    const price      : string | null = queryParams.get('price'      );
    const phoneNumber: string | null = queryParams.get('phoneNumber');

    token       && setToken      (token      );
    price       && setPrice      (price      );
    phoneNumber && setPhoneNumber(phoneNumber);
  }, [location]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section className={styles.redirectScreenContainer}>
      <CustomView.Container className={styles.boxWrapper}>
        <CustomView.Column extraSmall={12} medium={8} large={6} small={12} className={styles.box}>
          <h1 className={styles.headerTitle}>صفحه انتقال به درگاه پرداخت سنجد</h1>
          <div className={styles.body}>
            <li className={styles.textRow} style={{backgroundColor: '#ededed'}}>
              <p>مبلغ پرداختی:</p>
              <p>{price} تومان</p>
            </li>
            <li className={styles.textRow} style={{backgroundColor: '#f6f6f6'}}>
              <p>شماره تماس شما:</p>
              <p>{phoneNumber}</p>
            </li>
            <br/><br/>
            <CustomView.Row>
              <CustomView.Column className={styles.row} medium={6} small={12}>
                <CustomButton2 onClick={copyToClipboard} title={'کپی کردن لینک پرداخت'} type={'secondary'} />
              </CustomView.Column>
              <CustomView.Column className={styles.row} medium={6} small={12}>
                <CustomButton2 title={'لغو و برگشت به برنامه'} type={'danger'} onClick={() => alert('Not OK')} />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row>
              <form
                ref={formRef}
                action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
                method="post"
              >
                <input
                  type="hidden"
                  name="Token"
                  value={token}
                />
                <input name="GetMethod" type="hidden" value="true"/>
                <CustomView.Column className={styles.row} medium={12}>
                  <CustomButton2 isSubmit title={'انتغال به صفحه پرداخت'} onClick={redirectToPayment}/>
                </CustomView.Column>
              </form>
            </CustomView.Row>
          </div>
          <footer className={styles.footerTitle}>
            Senjedapp.ir &copy; 2024
            <a href={'https://pdade.net'} className={styles.link} target="_blank" rel="noopener noreferrer">Pejvak.</a>
            All rights reserved
          </footer>
        </CustomView.Column>
        <a href={'https://www.sep.ir'} target="_blank" rel="noopener noreferrer">
          <img className={styles.shaparakLogo} src={logo} alt={logo}/>
        </a>
      </CustomView.Container>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default RedirectScreen;
